// extracted by mini-css-extract-plugin
export var downArrow = "_an-0";
export var label = "_an-1";
export var treatmentCard = "_an-3";
export var upArrow = "_an-2";